import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ParticlesBackground from './components/ParticlesBackground';

// Pages
import Home from './pages/Home';
import Personalities from './pages/Personalities';
import Features from './pages/Features';
import UseCases from './pages/UseCases';
import Updates from './pages/Updates';
import About from './pages/About';
import FAQ from './pages/FAQ';
import Press from './pages/Press';
import Contact from './pages/Contact';

function App() {
  return (
    <div className="App min-h-screen relative">
      <BrowserRouter>
        {/* Background particles */}
        <ParticlesBackground />
        
        {/* Navigation */}
        <Navigation />
        
        {/* Main content */}
        <main className="relative z-10">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/personalities" element={<Personalities />} />
            <Route path="/features" element={<Features />} />
            <Route path="/use-cases" element={<UseCases />} />
            <Route path="/updates" element={<Updates />} />
            <Route path="/updates/:slug" element={<Updates />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/press" element={<Press />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        
        {/* Footer */}
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
